export enum SpinnerContainerIds {
  APPLICATION = 'application'
}
